// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3IvQv","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3kHnw","obliqueLine":"membershipbadge_obliqueLine__3Yf9k"};